import './template-string.scss';

import TemplateString from './TemplateString';

export default TemplateString;
